<!-- =========================================================================================
  File Name: ImageLibrary.vue
  Description: ImageLibrary
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div>
<upload-image-view @getdata="getdata" :upload="upload" @closeUpload="closeUpload" />
<folder-view-sidebar :isSidebarActive="addNewFolderSidebar" @getdata="getdata" @closeSidebar="toggleFolderSidebar" :data="folderSidebarData" />
<div>
<vs-tabs v-model="activeTab">
<vs-tab label="Uploads" icon-pack="feather" icon="icon-image" @click="setTab()">
<div class="flex justify-end mb-base">
<!-- <vs-button class="mr-4"  size="small" icon-pack="feather" icon="icon-plus"   @click="login()">Facebook</vs-button> -->
<vs-button class="mr-4" size="small" icon-pack="feather" icon="icon-upload" @click.native="upload=true">Upload</vs-button>
<!-- <vs-button class="mr-4"  size="small" icon-pack="feather" icon="icon-folder"  @click="DirectoryPopup=true">Upload Server Directory</vs-button> -->
<vs-button class="mr-4"  size="small" icon-pack="feather" icon="icon-plus"   @click.native="addNewFolder('0')">Create Folder</vs-button>
<vs-input icon-pack="feather" icon="icon-search" placeholder="Search" v-model="search" class="is-label-placeholder mt-0 mb-0" />
</div>

<div class="items-grid-view vx-row match-height" v-if="currentItemView == 'item-grid-view'" >
<!-- <div class="vx-col lg:w-1/12 sm:w-1/6 xs-w-1/3 w-full" v-for="folder in folders" :key="folder.id" > -->
<vs-col class="vx-col lg:w-1/12" vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="2"  vs-xs="3" v-for="folder in allFolders" :key="folder.id">
<folder-grid-view @getdata="getdata" :item="folder" ></folder-grid-view>
</vs-col>
<!-- </div>   -->
</div>
<!-- {{startLoding}} -->
{{endLoding}}
<div class="flex justify-between">
<div>
<small class="cursor-pointer hover:text-primary" @click="SelectALL()" v-if="SelectedItem.length==0" >Select All</small>
<small class="cursor-pointer hover:text-primary" @click="UnSelectALL()" v-if="SelectedItem.length > 0">Unselect All</small>
<vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-5 ml-5" v-if="SelectedItem.length > 0">
<div class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
<span class="mr-2">Actions ({{SelectedItem.length}})</span>
</div>
<vs-dropdown-menu>
<vs-dropdown-item  @click="deleteImgAction()">
<span class="flex items-center">
<feather-icon icon="TrashIcon"  svgClasses="h-4 w-4" class="mr-2" />
<span>Delete</span>
</span>
</vs-dropdown-item>
<vs-dropdown-item  @click="ResizePopup=true">
<span class="flex items-center">
<feather-icon icon="MaximizeIcon"  svgClasses="h-4 w-4" class="mr-2" />
<span>Resize</span>
</span>
</vs-dropdown-item>
</vs-dropdown-menu>
</vs-dropdown>
</div>
<div class="flex justify-end mb-5">
    <h6>Sort By :</h6> 
    <small class="ml-1" >Name
    <span @click="sortByName('desc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon v-if="sortNameIcon" icon="ChevronUpIcon" svgClasses="h-4 w-4"  />
    </span>
    <span @click="sortByName('asc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon  v-if="!sortNameIcon" icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
     </span>
    </small>

    <small class="ml-2">Upload
    <span @click="sortByTime('desc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon v-if="sortTimeIcon" icon="ChevronUpIcon" svgClasses="h-4 w-4"/>
    </span>
    <span @click="sortByTime('asc')" style="cursol:pointer" class="hover:text-primary">
    <feather-icon v-if="!sortTimeIcon" icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
    </span>
    </small>
</div>
</div>
<div class="items-grid-view vx-row match-height contained-example-container" v-if="currentItemView == 'item-grid-view'" v-viewer> 

<vs-col :id="'div-with-'+item.id" class="vx-col lg:w-1/6 vs-con-loading__container" vs-lg="2" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="3"  vs-xs="6" v-for="item in allImages" :key="item.id" >
<item-grid-view @selectItem="selectItem" @getdata="getdata" :item="item"></item-grid-view>

</vs-col>

</div>
     </vs-tab>
   <vs-tab label="Images" icon-pack="feather" icon="icon-facebook" @click="getFbFolder()" >
      <div class="items-grid-view vx-row match-height" v-if="currentItemView == 'item-grid-view'" >
      <vs-col class="vx-col lg:w-1/12" vs-lg="1" vs-type="flex" vs-justify="center" vs-align="center" vs-sm="2"  vs-xs="3" v-for="folder in directroy" :key="folder.id">
            <directory-grid-view @getdata="getdata" :item="folder"></directory-grid-view>
      </vs-col>
      </div>
    </vs-tab>
</vs-tabs>
</div>
<template slot="no-body">
<vs-popup title=" " :active.sync="ResizePopup">
    <vs-row >
        <!-- <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" style="border:2px solid black;background:black">
            <img :src="currentImg.url" alt="" style="height:500px">
            <img :src="resizeImg" alt="">
        </vs-col> -->
        <vs-col vs-type="flex" vs-justify="center"   vs-w="12">
         <vx-card  title="Resize Image" title-color="primary" subtitle="Enter Width (px) eg. 200">
           <vs-input v-model="imgWidth"></vs-input>
           <vs-button size="small" @click.native="resizeAction(imgWidth,SelectedItem)" :disabled="setDisable" class="mt-2">Set</vs-button>
         </vx-card>
        </vs-col>
    </vs-row>
</vs-popup>
            
</template>

                           <!-- <template slot="no-body">
                <vs-popup  title="Enter Directory Path" :active.sync="DirectoryPopup">
                <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="10" >
                    <vs-input class="w-full" v-model="dataPath"></vs-input>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="2" >
                   <vs-button @click="ServerUpload">Upload</vs-button>
                </vs-col>
               </vs-row>
            </vs-popup>
            </template> -->
<!-- <template slot="no-body">
<vs-popup  title="Facebook Pages" :active.sync="FacebookPopup">
   <div class="vx-row mb-3">
    <div class="vx-col w-full">
      <label class="vs-select--label w-full">Select Page</label>
      <v-select  label="name" class="w-full" v-model="dataPage" @input="getAlbum()" multiple :closeOnSelect="true"  :options="FbPages"/>
    </div>
  </div>
   <div class="vx-row mb-3" v-if="dataPage.length > 0">
    <div class="vx-col">
    <label class="vs-select--label w-full">Select Album</label>
    <ul class="mt-3">
      <li v-for="album in FbAlbums" :key=album.id class="inline-flex">
        <vs-checkbox v-model="dataAlbum" @change="getPhotos()" :vs-value="album">{{album.name}}</vs-checkbox>
      </li>
    </ul>
    </div>
  </div>
  <div class="vx-row mb-3">
    <div class="vx-col w-full">
      <vs-button class="mr-3" @click="getFBImages()" :disabled="!(dataPage.length > 0 && dataAlbum.length > 0)">Get </vs-button>
      <vs-button class="mr-3" color="success" @click="SaveImages()" :disabled="!(FBImages.length > 0)">Save</vs-button>
    </div>
    <div class="vx-col w-full">
    </div>
  </div>
    <span v-for="img in FBImages" :key=img.id>
      <img :src="img.picture" alt="">
    </span>

</vs-popup>
</template> -->
<!-- <template slot="no-body">
<vs-popup  title=" "  :active.sync="MainUploadPopup">
  <div class="vx-row">
    <div class="vx-col w-full">
  <div>
    <vs-tabs v-model="MainPopupTabIndex">
      <vs-tab label="Upload from PC" icon-pack="feather"  icon="icon-image" >
      <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <input type="file" class="hidden" multiple ref="uploadImageInput" @change="uploadNewImage" accept="image/*">
        <vs-button  icon-pack="feather" icon="icon-upload" @click="$refs.uploadImageInput.click()">Upload</vs-button>
        </vs-col>
      </vs-row>
      </vs-tab>
      <vs-tab label="Upload from ServerPath" icon-pack="feather"  icon="icon-folder">
              <vs-row>
                <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12" >
                  <vs-input placeholder="Enter Path" class="is-label-placeholder inline-flex" v-model="dataPath"></vs-input><vs-button class="mt-5" @click="ServerUpload">Upload</vs-button>
                </vs-col>
               </vs-row>
      </vs-tab>
      <vs-tab label="Upload form FB" icon-pack="feather" icon="icon-facebook">
        <vs-row>
        <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-w="12">
        <vs-button icon-pack="feather" icon="icon-facebook"   @click="login()">Login with Facebook</vs-button>
        </vs-col>
      </vs-row>
      </vs-tab>
    </vs-tabs>
  </div>
    </div>
  </div> 
</vs-popup>
</template> -->
</div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
  import Viewer from 'v-viewer'
  import Vue from 'vue'
  Vue.use(Viewer)
import draggable from 'vuedraggable'
import FolderViewSidebar from './FolderViewSidebar.vue'
import {
GET_IMAGE_LIBARY,
GET_FOLDER,
BULK_DELETE_IMAGES,
GET_FACEBOOK_FOLDER,
BULK_RESIZE_IMAGES
} from '@/graphql'
export default {
  components: {
    ItemGridView: () => import('./components/ItemGridView.vue'),
    FolderGridView: () => import('./components/FolderGridView.vue'),
    DirectoryGridView: () => import('./components/DirectoryGridView.vue'),
    UploadImageView: () => import('./components/UploadImageView.vue'),
    FolderViewSidebar,
    draggable,
  },
  data () {
    return {
      activeTab:0,
      currentItemView: 'item-grid-view',
      addNewFolderSidebar: false,
      folderSidebarData : null,
      orignal_images:[],
      orignal_folders:[],
      images:[],
      folders:[],
      directroy:[],
      sortNameIcon:false,
      sortTimeIcon:true,
      activeLoading:false,
      SelectedItem:[],
      upload:false,
      search:null,
      ResizePopup:false,
      imgWidth:null,
     
    }
  },
  computed: {
    allFolders(){
       return this.folders
    },
     allImages(){
       return this.images
    },
    endLoding(){
      let ids = this.$store.getters.getCompleteResizeImg
      if(ids && ids.length>0){
        let items = JSON.parse(localStorage.getItem('resize_imgs'))
        ids.forEach(id => {
         this.$vs.loading.close(`#div-with-${id} > .con-vs-loading`)
         let index = items.imgs.indexOf(id);
          if (index !== -1) {
             items.imgs.splice(index, 1); 
             localStorage.setItem('resize_imgs', JSON.stringify(items))
          }
      });
      this.SelectedItem=[] 
      this.get()
      }
      // console.log(JSON.parse(localStorage.getItem('resize_imgs')))


      //  this.$vs.loading({
      //   container: `#div-with-${id}`,
      //   scale: 0.6
      // })
      // setTimeout( ()=> {
        // this.$vs.loading.close(`#div-with-${id} > .con-vs-loading`)
        // var remov_id = selected.indexOf(id);
        //   if (remov_id > -1) {
        //     selected.splice(remov_id, 1);
        //   }
          //  objIndex = images((obj => obj.id == id));
          //  images[objIndex].check = false

      // }, 3000);
      // this.images = images
      // this.SelectedItem = selected
      // else{
      //   console.log("closeAll")
      //   setTimeout( ()=> {
      //   this.$vs.loading.close()
      // }, 3000);
      // }
        //  return this.$store.getters.getCompleteResizeImg
    },
    // startLoding(){
    //    let ids = this.$store.getters.getStartResizeImg
    //    if(ids && ids.length>0){
    //     ids.forEach(id => {
    //       this.$vs.loading({
    //       container: `#div-with-${id}`,
    //       scale: 0.6
    //     })
    //   });
    //    }

    // },
setDisable(){ 
        if(this.imgWidth && this.SelectedItem.length>0){
                return false
            }
            else{
               return true
            }
        }
  },
 watch: {
  ResizePopup:function (val) {
     if(!val){
       this.SelectedItem=[]
       this.imgWidth=null
     }
    }, 
    search: function (val) {
       if(val){
        this.images = this.orignal_images.filter(img => {
        return img.name.toLowerCase().includes(val.toLowerCase())
        })
        this.folders = this.orignal_folders.filter(folder => {
        return folder.name.toLowerCase().includes(val.toLowerCase())
        })
      }
      else{
        this.images=this.orignal_images
        this.folders=this.orignal_folders
      }
    }
    },
methods: {   
closeUpload(val){
    this.upload=val
}, 
getFbFolder(){
localStorage.setItem('storedActiveTab',this.activeTab)      
this.$apollo
      .mutate({
        mutation: GET_FACEBOOK_FOLDER
      })
      .then(response => {
      if(response.data.getfacebookFolder.status==='Success'){
      this.directroy=response.data.getfacebookFolder.folder
      }
    }).catch(error => {
      console.log(error)
    })
  },
// SaveImages(){
//         this.loader()
//         this.$apollo
//         .mutate({
//           mutation: SAVE_FB_IMAGES,
//           variables: {
//             imgs: this.FBImages,
//           }
//         })
//         .then(response => {
//             if(response.data.saveFbImgs.status==='Success'){
//                 this.$vs.notify({
//                   title: 'Images',
//                   text: 'Facebook Images Save Successfully',
//                   color: 'success',
//                   position: 'top-right'
//                 })
//                    this.FacebookPopup=false
//                    this.MainUploadPopup=false
//             //       this.get()
//                   this.activeLoading = false
//                   this.$vs.loading.close()
//              }
//     })
// },  
//  getFBImages(){
//    let _this=this
//    this.FBImages=[]
//    for (let index = 0; index < this.FBPhotos.length; index++) {
//           let photo_id = this.FBPhotos[index].id;
//              FB.api('/'+photo_id+'?fields=images,picture,from,album',
//               function (response) {
//                 if (response && !response.error) {
//                     console.log(response)
//                    _this.FBImages.push(response)
//                 }
//               }
//           );
//         }
//  },  
//  getPhotos(){
//         this.FBPhotos=[]
//         for (let index = 0; index < this.dataAlbum.length; index++) {
//           // console.log(this.dataAlbum[index])
//           let album_id = this.dataAlbum[index].id;
//           // let result = this.getPhotosFromAlbum('/'+album_id+'/photos')
//           this.getPhotosFromAlbum('/'+album_id+'/photos')
//         }
//     },
// getPhotosFromAlbum(link){
//     let _this=this
//      FB.api(
//           link,
//           function (response) {
//             if (response && !response.error) {
//              for (let photo = 0; photo < response.data.length; photo++) {
//                 _this.FBPhotos.push(response.data[photo]);
//               }
//               if(response.paging.next){
//                 _this.getPhotosFromAlbum(response.paging.next)
//               }
//             }
//           }
//       );
// },
//     getAlbum(){
//         this.FbAlbums=[]
//         for (let index = 0; index < this.dataPage.length; index++) {
//           // console.log(this.dataPage[index])
//           let page_id = this.dataPage[index].id;
//           this.getAlbumFromPage('/'+page_id+'/albums')
//         }
//     },
//     getAlbumFromPage(link){
//     let _this=this
//     FB.api(link,
//             function (response) {
//               if (response && !response.error) {
//               for (let alb = 0; alb < response.data.length; alb++) {
//                 _this.FbAlbums.push(response.data[alb]);
//               }
//               if(response.paging.next){
//                 _this.getAlbumFromPage(response.paging.next)
//               }
//              }
//             }
//         );
//     },
//     login(){
//       let _this = this
//       // _this.FbLogout()
//       FB.getLoginStatus(function(response) {
//         // console.log(response)
//         if(response.status === 'connected'){
//           // console.log(response)
//            localStorage.setItem('storedFbUserID', response.authResponse.userID)
//            _this.getUserPage() 
//           // _this.FbMeData();
//         }
//         else{
//         FB.login(function(response){
//          if(response.status === 'connected'){
//           var appID= _this.appID
//           var appSecret= _this.appSecret
//           console.log(response)
//           fetch('https://graph.facebook.com/oauth/access_token?client_id='+appID+'&client_secret='+appSecret+'&grant_type=fb_exchange_token&fb_exchange_token='+response.authResponse.accessToken).then(function(response) {
//           return response.json();
//         }).then(function(data) {
//           localStorage.setItem('storedFbToken', data.access_token)
//         }).catch(function() {
//           console.log("Token Error");
//         });
//          }
//          else{
//            localStorage.removeItem('storedFbToken')
//            localStorage.removeItem('storedFbUserID');
//          }
//          } ,{scope: 'public_profile,pages_show_list,pages_read_engagement'});
//         }
//          });
  
//     },
//     getUserPage(){
//        let _this = this
//       let user_id = localStorage.getItem('storedFbUserID');
//           FB.api('/'+user_id+'/accounts',
//           function (response) {
//             if (response && !response.error) {
//               _this.FbPages=response.data
//               _this.FacebookPopup=true
//             }
//           }
//         );    
//     },
//     FbLogout(){
//       FB.logout(function(response) {
//             console.log(response)
//           });
//     },
//     FbMeData(){
//         FB.api('/me', function(response) {
//         if (response && !response.error){
//         localStorage.setItem('storedFbUserName', response.name)
//         // console.log('Successful login for: ' + response.name);
//         }
//         else{
//           console.log(response.error)
//         }
//       //   });
//       //   FB.api('/me/permissions', function(response) {
//       //   console.log(response)
//         });
        

//     },
    SelectALL(){
     for (let index = 0; index < this.images.length; index++) {
       this.images[index].check=true
       this.SelectedItem.push(this.images[index].id)
     }
    },
    UnSelectALL(){
      this.SelectedItem=[]
      for (let index = 0; index < this.images.length; index++) {
       this.images[index].check=false
     }
    },
    resizeAction(width,imgs){
      this.ResizePopup=false
      localStorage.setItem('resize_imgs',JSON.stringify({'imgs':imgs,'width':width}))
      imgs.forEach(element => {
        console.log(element)
        this.$vs.loading({
        container: `#div-with-${element}`,
        scale: 0.6,
        type:'material'
      })
      });
      this.$store.dispatch('setResizeImgs', {'width':width,'imgs':imgs})
      // this.loader()
      // this.$apollo
      //   .mutate({
      //     mutation: BULK_RESIZE_IMAGES,
      //     variables: {
      //           id: this.SelectedItem,
      //           width:width
      //     }
      //   })
      //   .then(response => {
      //     console.log(response)
      //       if(response.data.bulkResizeImges.status==='Success'){
      //           this.$vs.notify({
      //             title: 'Images',
      //             text: 'Resize Successfully',
      //             color: 'success',
      //             position: 'top-right'
      //           })
      //             this.SelectedItem=[] 
      //             this.get()
      //             this.activeLoading = false
      //             this.$vs.loading.close()
      //             this.ResizePopup=false
      //        }
      //           })
    },
    deleteImgAction(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to permanently delete"`,
        accept: this.sureDeleteData,
        acceptText: 'Delete'
      })
    },
    sureDeleteData(){     
      this.loader()
        this.$apollo
        .mutate({
          mutation: BULK_DELETE_IMAGES,
          variables: {
                id: this.SelectedItem,
          }
        })
        .then(response => {
          console.log(response);
            if(response.data.bulkDeleteImges.status==='Success'){
                this.$vs.notify({
                  title: 'Images',
                  text: 'Deleted successfully',
                  color: 'success',
                  position: 'top-right'
                })
                  this.SelectedItem=[] 
                  this.get()
                  this.activeLoading = false
                  this.$vs.loading.close()
             }
             else{
                 this.$vs.notify({
                  title: 'Images',
                  text:  response.data.bulkDeleteImges.message,
                  color: 'danger',
                  position: 'top-right'
                })
                  this.SelectedItem=[] 
                  this.activeLoading = false
                  this.$vs.loading.close()
             }
            })
    },
    selectItem(id){
       let status = false
        for (let i = 0; i < this.SelectedItem.length; i++) {
          if (this.SelectedItem[i] === id) {
            this.SelectedItem.splice(i, 1)
            status = true
          }
        }
        if (!status) {
          this.SelectedItem.push(id)
        }
    },
// ServerUpload(){
//   if(this.dataPath){
//         this.loader()
//         this.$apollo
//         .mutate({
//           mutation: GET_DIRECTORY_IMAGES,
//           variables: {
//                 path: this.dataPath,
//           }
//         })
//         .then(response => {
//           console.log(response)
//             if(response.data.getDirectoryImages.status==='Success'){
//               this.getFolder()
//               //  for (let index = 0; index < response.data.getDirectoryImages.images.length; index++) {
//               //     response.data.getDirectoryImages.images[index];
//               // this.folders.unshift(response.data.getDirectoryImages.folder);
//               //  }
//                 this.activeLoading = false
//                 this.$vs.loading.close()
//                 this.dataPath=null
//                 this.DirectoryPopup=false
//                 this.MainUploadPopup=false
//             }
//             else{
//                   this.$vs.notify({
//                   title: 'Directory',
//                   text: 'Please Enter a valid path',
//                   color: 'danger',
//                   position: 'top-right'
//                 })
//                 this.activeLoading = false
//                 this.$vs.loading.close()
//                  this.dataPath=null
//                 this.DirectoryPopup=false
//                 // this.MainUploadPopup=false
//             }
       
//           })
//   }else{
//         this.$vs.notify({
//         title: 'Directory',
//         text: 'Path is required!',
//         color: 'danger',
//         position: 'top-right'
//       })
//   }
// },
loader () {
  this.activeLoading = true
  this.$vs.loading({
  type:'sound'
  })
},  
  sortByName(type){
    this.sortNameIcon=!this.sortNameIcon
    if(type==='desc'){
          this.images.sort(function (a, b) {
          const textA = a.name.toUpperCase()
          const textB = b.name.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
    }
    else{    
          this.images.sort(function (a, b) {
          const textA = a.name.toUpperCase()
          const textB = b.name.toUpperCase()
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
    }
  },
    sortByTime(type){
    this.sortTimeIcon=!this.sortTimeIcon
    if(type==='desc'){
          this.images.sort(function (a, b) {
          const textA = a.created_at
          const textB = b.created_at
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
    }
    else{    
          this.images.sort(function (a, b) {
          const textA = a.created_at
          const textB = b.created_at
          return (textA < textB) ? 1 : (textA > textB) ? -1 : 0
        })
    }
  },
  getdata (value) {
      if (value==='folder') {
        this.getFolder()
      }
      if(value==='image'){
        this.get()
      }
      if(value==='fbfolder'){
        this.getFbFolder()
      }
  },

     addNewFolder (data) {
      this.folderSidebarData = data
      this.toggleFolderSidebar(true)
    },
    toggleFolderSidebar (val = false) {
      this.addNewFolderSidebar = val
    },  
    // SaveFile (response, orignal_name) {

    //   if (response) {
    //     var key = response.key
    //     var location = response.location
    //     this.$apollo
    //     .mutate({
    //       mutation: ADD_IMAGE_TO_LIBRARY,
    //       variables: {
    //             name: orignal_name,
    //             key: key,
    //             url: location,
    //             folder:'0'
    //       }
    //     })
    //     .then(response => {
    //         if(response.data.addImageToLibrary.status==='Success'){
    //           this.get()
    //           //  this.images.unshift({
    //           //    'id':response.data.addImageToLibrary.color,
    //           //    'name':orignal_name,
    //           //     'key':key,
    //           //     'url':location,
    //           //      'folder':'0',
    //           //      'check':false,
    //           //      'created_at':response.data.addImageToLibrary.message
    //           //  });
    //          }
    //             this.MainUploadPopup=false
    //             this.activeLoading = false
    //             this.$vs.loading.close()

             
    //     }
    //     )

    //   }
    // //   console.log(this.uplodedfiles)

    // },
    // uploadNewImage () {
    //   this.loader()
    //   for (let i = 0; i < this.$refs.uploadImageInput.files.length; i++) {
    //       const file = this.$refs.uploadImageInput.files[i]
    //       const orignal_name = this.$refs.uploadImageInput.files[i].name
    //       const name = Math.random().toString().slice(2)
    //     //   this.openLoadingInDiv()
    //       S3Client
    //         .uploadFile(file, name)
    //         .then(response => {
    //             console.log(response)
    //         //   this.$vs.loading.close('#div-with > .con-vs-loading')
    //           this.SaveFile(response, orignal_name)
    //         })
    //         .catch(err => console.error(err))
    //   }

    // },
    get(){
      this.$apollo
      .mutate({
        mutation: GET_IMAGE_LIBARY
      })
      .then(response => {
      this.images=response.data.getImageLibrary
      for (let index = 0; index < this.images.length; index++) {
        this.images[index].check=false;
      }
      this.orignal_images=this.images
       if(localStorage.getItem('resize_imgs')){
      let data = JSON.parse(localStorage.getItem('resize_imgs'))
     if(data.imgs && data.imgs.length>0 && data.width){
               setTimeout( ()=> {
        this.resizeAction(data.width,data.imgs)

      }, 5000);
       
     }
    }
    }).catch(error => {
      console.log(error)
    })
    },
      getFolder(){
      this.$apollo
      .mutate({
        mutation: GET_FOLDER
      })
    .then(response => {
      if(response.data.getFolder.status==='Success'){
      this.folders=response.data.getFolder.folder
      this.orignal_folders=this.folders
      }
    }).catch(error => {
      console.log(error)
    })
    },
  setTab(){
    localStorage.removeItem('storedActiveTab')      
  }     
  },
  //   mounted () {
  //   let _this = this
  //   this.$nextTick(() => {
  //     window.fbAsyncInit = function () {
  //       FB.init({
  //         appId: process.env.VUE_APP_FB_APP_ID,
  //         xfbml: true,
  //         version: 'v2.6'
  //       })
  //       FB.AppEvents.logPageView()
  //       _this.FB = FB
  //       console.log('FB SDK was initialized as mixin')
  //     };
  //     (function (d, s, id) {
  //       let js, fjs = d.getElementsByTagName(s)[0]
  //       if (d.getElementById(id)) { return }
  //       js = d.createElement(s); js.id = id
  //       js.src = '//connect.facebook.net/en_US/sdk.js'
  //       fjs.parentNode.insertBefore(js, fjs)
  //     }(document, 'script', 'facebook-jssdk'))
  //   })
  // },

  created () {
    if(localStorage.getItem('storedActiveTab')){
     this.activeTab=localStorage.getItem('storedActiveTab')
     this.getFbFolder()
    }
    this.appID=process.env.VUE_APP_FB_APP_ID  
    this.appSecret=process.env.VUE_APP_FB_APP_SECRET_ID
    this.getFolder()
    this.get()
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.img_cdn=this.img_cdn.replace('/images','');
  },

}

</script>


<style lang="scss">
#algolia-instant-search-demo {
  .algolia-header {
    .algolia-filters-label {
      width: calc(260px + 2.4rem);
    }
  }

  #algolia-content-container {

    .vs-sidebar {
      position: relative;
      float: left;
    }
  }

  .algolia-search-input-right-aligned-icon {
    padding: 1rem 1.5rem;
  }

  .algolia-price-slider {
    min-width: unset;
  }

  .item-view-primary-action-btn {
    color: #2c2c2c !important;
    background-color: #f6f6f6;
    min-width: 50%;
  }

  .item-view-secondary-action-btn {
    min-width: 50%;
  }
}

.theme-dark {
  #algolia-instant-search-demo {
    #algolia-content-container {
      .vs-sidebar {
        background-color: #10163a;
      }
    }
  }
}

@media (min-width: 992px) {
  .vs-sidebar-rounded {
    .vs-sidebar {
      border-radius: .5rem;
    }

    .vs-sidebar--items {
      border-radius: .5rem;
    }
  }
}

@media (max-width: 992px) {
  #algolia-content-container {
    .vs-sidebar {
      position: absolute !important;
      float: none !important;
    }
  }
}

</style>
